import { render, staticRenderFns } from "./BeaconCamera.vue?vue&type=template&id=73064d3a&"
import script from "./BeaconCamera.vue?vue&type=script&lang=ts&"
export * from "./BeaconCamera.vue?vue&type=script&lang=ts&"
import style0 from "./BeaconCamera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports